import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

export default function CustomerLogin() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [checkingAuth, setCheckingAuth] = useState(true);

  useEffect(() => {
    const checkUser = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (session?.user) {
          localStorage.setItem('customerEmail', session.user.email || '');
          const redirectTo = sessionStorage.getItem('redirectAfterLogin');
          if (redirectTo) {
            sessionStorage.removeItem('redirectAfterLogin');
            navigate(redirectTo);
          } else {
            navigate('/customer-dashboard');
          }
        }
      } catch (err) {
        console.error('Error checking session:', err);
      } finally {
        setCheckingAuth(false);
      }
    };
    checkUser();

    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      async (event, session) => {
        console.log('Auth event:', event, session);
        if (event === 'SIGNED_IN' && session?.user) {
          localStorage.setItem('customerEmail', session.user.email || '');
          const redirectTo = sessionStorage.getItem('redirectAfterLogin');
          if (redirectTo) {
            sessionStorage.removeItem('redirectAfterLogin');
            navigate(redirectTo);
          } else {
            navigate('/customer-dashboard');
          }
        }
      }
    );

    return () => subscription.unsubscribe();
  }, [navigate]);

  const handleGoogleLogin = async () => {
    setLoading(true);
    try {
      // redirectAfterLogin varsa onu hedef al, yoksa customer-dashboard
      const redirectPath = sessionStorage.getItem('redirectAfterLogin') || '/customer-dashboard';
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: `${window.location.origin}/siparis-takibi/customer-login`,
        },
      });
      if (error) throw error;
    } catch (err: any) {
      console.error('Google login error:', err);
      alert('Giriş yapılırken bir hata oluştu. Lütfen tekrar deneyin.');
      setLoading(false);
    }
  };

  if (checkingAuth) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-green-500"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-xl lg:rounded-2xl shadow-sm border border-gray-200 p-6 lg:p-8">
          <div className="text-center mb-6 lg:mb-8">
            <img
              src="https://static.readdy.ai/image/4d025bfd0dded7d3f58fab80d1f8fe1d/58617c13764fc3aa761818d509f07204.png"
              alt="Kartvizitler Logo"
              className="h-20 lg:h-24 w-auto object-contain mx-auto mb-4"
            />
            <h1 className="text-xl lg:text-2xl font-bold text-gray-900 mb-1 lg:mb-2">
              Müşteri Girişi
            </h1>
            <p className="text-xs lg:text-sm text-gray-600">
              Sipariş takibi için Google hesabınızla giriş yapın
            </p>
          </div>

          <button
            onClick={handleGoogleLogin}
            disabled={loading}
            className="w-full flex items-center justify-center gap-3 bg-white border border-gray-300 rounded-lg py-3 px-4 hover:bg-gray-50 transition-all disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer shadow-sm"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.21 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
            </svg>
            <span className="text-sm font-medium text-gray-700">
              {loading ? 'Yönlendiriliyor...' : 'Google ile Giriş Yap'}
            </span>
          </button>

          <div className="mt-5 lg:mt-6 pt-5 lg:pt-6 border-t border-gray-200 text-center">
            <a
              href="https://xkartvizitler.com/siparis-takibi/admin-login"
              className="text-sm text-gray-600 hover:text-gray-900 cursor-pointer"
            >
              Yönetici girişi için tıklayın
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
